import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddressPopupForm from './AddressPopupForm';

import { CardTypes } from '../../utils/enums';

import {
    onAddressSubmit,
    onPostalCodeChange
} from '../../containers/VoteRegistration/actions';

import {
    AnimationContainer,
    ContainerAbsolute,
    Body
} from '../../containers/DefaultStyles/AssessmentDetails';

import { cacheFormData } from '../../utils/formCaching/actions';

const AddressPopup = props => (
    <AnimationContainer>
        <ContainerAbsolute>
            <Body>
                <AddressPopupForm
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.onAddressSubmit(
                            props.apiRequestData,
                            values,
                            props.id,
                            props.state,
                            props.localRepLoaded,
                            props.isPostalCodeChanged,
                            props.actionIdentifier,
                            props.isMultiActionsCard
                        );
                    }}
                    onBack={props.onBack}
                    isAddressSubmitting={props.isAddressSubmitting}
                    month={props.month}
                    year={props.year}
                    day={props.day}
                    onPostalCodeChange={props.onPostalCodeChange}
                    isErrorOnSubmit={props.isErrorOnSubmit}
                />
            </Body>
        </ContainerAbsolute>
    </AnimationContainer>
);

AddressPopup.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    cacheFormData: PropTypes.func.isRequired,
    day: PropTypes.array,
    id: PropTypes.number,
    isAddressSubmitting: PropTypes.bool,
    isErrorOnSubmit: PropTypes.bool,
    localRepLoaded: PropTypes.bool,
    isMultiActionsCard: PropTypes.bool.isRequired,
    isPostalCodeChanged: PropTypes.bool,
    month: PropTypes.array,
    onAddressSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func,
    onPostalCodeChange: PropTypes.func,
    state: PropTypes.string,
    year: PropTypes.array
};

export default connect(
    state => {
        let year = [];
        for (var i = 0; i < 100; i++) {
            year.push(new Date().getUTCFullYear() - i);
        }

        let day = [];
        for (i = 1; i <= 31; i++) {
            day.push(i);
        }

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            apiRequestData: state.widget.apiRequestData,
            day,
            id: state.widget.activeAction.id,
            isAddressSubmitting: state.voteRegistration.isAddressSubmitting,
            isErrorOnSubmit: state.voteRegistration.isErrorOnSubmit,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isPostalCodeChanged: state.voteRegistration.isPostalCodeChanged,
            localRepLoaded: state.localRep.localRepData.representative !== undefined,
            month: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            state: state.widget.endUserLocation?.region,
            year
        };
    },
    {
        onAddressSubmit,
        onPostalCodeChange,
        cacheFormData
    }
)(AddressPopup);
